module.exports = __webpack_public_path__ + "static/tournage2-7b5103d85105c2f6b4e7b9d41d2e41bc.jpg";